//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TimelineItemCard from "../utils/timeline-card.vue";
import ChangelogMixin from "@Broker/@Modules/clients/board/client-profile/mixins/changelog-mixin.js";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ChangelogBoardStatus",
  components: {
    TimelineItemCard
  },
  mixins: [ChangelogMixin],
  props: {
    value: {
      type: null,
      required: true
    },
    operation: {
      type: String,
      required: true
    },
    field: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    userDetails: {
      type: Object,
      required: true
    },
    insertionTimestamp: {
      type: String,
      required: true
    }
  }
});